var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSantaWithGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 684.026,
    height: 678.338,
    viewBox: "0 0 684.026 678.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 524.865,
    height: 514.127,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "matrix(0.921, 0.391, -0.391, 0.921, 200.886, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M164.379,0c-23.51,6.284-51.886,12.311-80.111,13.445C57.3,14.53,30.5,10.986,6.957,5.919L0,26.778c63.009,16.489,132.325,25.8,170.154,3.711Z",
    transform: "translate(104.404 139.066)",
    fill: "#c93f4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M36.845,14.712C31.946,9.905,19.679-1.646,17.752.2c-1.113,1.065,3.556,6.788,5.816,10.06C15.906,8.476.839,6.016.034,9.985-.843,14.291,15.581,20.2,34.293,22.009Z",
    transform: "translate(68.444 137.107)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M12.028.206C9.132-.579,7.61.891,6.548,4.384c-.9,3.448-1.794,6.9-2.815,10.457C2.88,17.825,2.668,20.4.837,24.092c-1.326,2.683-1.382,4.5,2.1,5.734,2.752.976,3.42,1.239,7.906,2.577,3.036.906,4.438-.442,5.074-3.338,1.034-4.689,1.4-7.012,2.647-10.348,1.77-4.71,1.878-7.225,3.012-10.666,1.129-3.424.016-5.939-3.052-6.324a38.362,38.362,0,0,1-6.5-1.522",
    transform: "translate(97.082 139.024)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M195.637,2.345l-.291,42.688C122.989,38.916,68.415,38.057,3.86,41.518L0,15.41C55.563.3,116.657-2.894,195.637,2.345",
    transform: "translate(39.581 219.299)",
    fill: "#c93f4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M36.313,18.018C31.631,15.578,25.539,12.4,19.6,9.131,10.064,3.878,1.148-1.056.151.2-.922,1.543,3.888,5.722,9.427,10.736c4.221,3.818,9.031,8.237,12.324,11.384a31.794,31.794,0,0,0-5.2.673c-1.374.353-1.3,1.9-1.122,3.616s.653,3.315,1.61,3.4c2.055.189,13.486-1.454,19.9-2.552Z",
    transform: "translate(0 227.931)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M8.1.362c4.71-1.141,5.663.388,6.408,4.961.645,3.936.668,7.645,1.967,14.836.985,5.448,3.845,11.208.056,12.259a30.752,30.752,0,0,1-6.653.79c-1.938.1-3.36.361-4.626-.79-1.426-1.292-1.337-4.933-2.183-7.508C2.107,19.359,1.687,14.879,1.15,12.872-.753,5.723-.488,1.949,3.413,1.358Q5.78.926,8.1.362",
    transform: "translate(30.361 231.027)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M.285,11.113c4.586,2.611,10.558,6.007,16.376,9.5,9.334,5.6,18.061,10.86,19.1,9.645,1.121-1.306-3.531-5.66-8.881-10.874-4.075-3.972-8.723-8.564-11.9-11.831a31.813,31.813,0,0,0,5.225-.481c1.385-.3,1.365-1.849,1.252-3.573S20.935.161,19.981.037C17.937-.228,6.451.993,0,1.854Z",
    transform: "translate(470.146 388.249)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M53.594,8.054c43.37,36.819,93.5,103.364,140.828,162.052L1.965,241.971C-.425,170.083-2.359,109.693,7.043,40.187,9.71,20.465,18.129,5.122,29.358,1c7.293-2.676,16.049.1,24.236,7.049",
    transform: "translate(227.334 102.384)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M112.671,0c-1.8.624-3.591,1.287-5.394,1.92-7.9,2.771-15.843,5.443-23.65,8.429C69.272,15.841,55.352,22.178,40.762,27.267c-9.485,3.309-19.272,6.118-28.671,8.991C8.2,37.444,4.262,38.589.312,39.6Q.138,43.557,0,47.51c9.749-2.35,19.317-5.5,28.733-8.372,8.954-2.734,17.817-5.757,26.61-9.228C68.1,24.876,80.7,19.377,93.66,14.747c7.1-2.539,14.293-4.98,21.37-7.5.978-.347,1.963-.679,2.954-.984Q115.323,3.107,112.671,0",
    transform: "translate(227.943 172.312)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M48.371,0c2.846,76.256,37.359,90.738,111.561,85.607l3.712,27.365C83.725,136.842,12.7,113.207,0,17.956Z",
    transform: "translate(300.218 298.822)",
    fill: "#c93f4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M46.946,9.977c57.191-2.436,74.119,8.3,58.631,12.916,15.793,7.433,41.252,19.489,38.319,29.942-1.617,5.765-14.957,6.974-32.871,7.557-5.639-5.485-11.19-10.577-16.635-15.2-8.187-6.95-16.943-9.725-24.236-7.049C58.926,42.262,50.507,57.606,47.839,77.326l7.571,2.429c13.688,30.007,61.865,61.229,57.809,69.427-3.3,6.676-33.4-8.557-50.344-20.25,9.895,12.923,35.864,43.987,28.24,50.99C83.8,186.643,55.25,163.861,42.606,143.2c4.833,12.012,7.99,24.25,3.423,25.55C29.774,173.378-26.208,78.608,14.6,0Z",
    transform: "translate(186.538 65.244)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M39.294,29.622c-.217,3.709-.588,7.862-1.384,13.237L0,36.119c3.671-8.571,4.64-18.52,6.282-23.49C9.493,2.913,15.362-.964,22.182.2c25.379,4.326,55.7,23.018,86.067,40.568l-.808,1c-9.956-3-25.922-8.1-40.383-10.882C55.418,28.641,44.7,28.141,39.294,29.622",
    transform: "translate(203.693 20.097)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M47.541,8.122C42.836,23.046,15.057,26.955,0,23.5L10.548,0Z",
    transform: "translate(189.54 67.102)",
    fill: "#ffd3c0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M14.446.167C11.718-1.76,1.877,13.552.308,18.418c-1.241,3.849,1.388,7.266,5.651,1.51-.246,1.61,1.761,2.079,2.974-.153C11.617,14.834,16.141,1.364,14.446.167",
    transform: "translate(184.665 70.928)",
    fill: "#ffa195",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M22.561,2.9A115.339,115.339,0,0,0,42.327,5.516c5.37-.281,8.672,1.4,7.423,7.39a61.866,61.866,0,0,0-1.46,8.307c-.152,2.879-2.324,3.215-7.551,1.874A120.862,120.862,0,0,0,23.35,20.247c-5.433-.7-9.4-1.47-16.463-2.5-3.445-.5-7.118-.712-6.876-3.8C-.031,9.781.882,6.978,1.053,3.921,1.219.954,3.226-.151,5.235.016A123.107,123.107,0,0,1,22.561,2.9",
    transform: "translate(196.211 54.393)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M0,7.282A25.437,25.437,0,0,0,4.39,0c4.9.633,8.262,2.888,6.956,6.168C10.089,9.332,4.868,10.185,0,7.282",
    transform: "translate(234.737 79.678)",
    fill: "#ffd3c0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M2.23,0a4.694,4.694,0,0,1,.855.081,4.221,4.221,0,0,1,.682.173A3.38,3.38,0,0,1,5.836,1.475a1.509,1.509,0,0,1-.483,1.948,3.673,3.673,0,0,1-3.7.233A5.554,5.554,0,0,1,.3,2.6,1.162,1.162,0,0,1,0,1.811,1.915,1.915,0,0,1,1.73.043,3.364,3.364,0,0,1,2.23,0",
    transform: "translate(238.281 82.526)",
    fill: "#ffa195",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M11.037,4.762C11.058-2.821,2.913-.89,0,7.321A57.8,57.8,0,0,0,11.037,4.762",
    transform: "translate(210.179 83.838)",
    fill: "#ffa195",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M10.389,6.7l-.61,1.643C4.673-1.84,1.615,1.181,1.315,3.315c-.4.473-.8.979-1.209,1.509C-.81.944,4.316-4.577,10.389,6.7",
    transform: "translate(192.677 71.26)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M0,2.276c.22,1.189,1.37,1.968,2.427,2.511A10.275,10.275,0,0,0,7.99,5.977c1.175-.085,2.644-.487,2.51-1.847C10.251,1.606,6.774.572,4.1.07,2.728-.178-.115.156,0,2.276",
    transform: "translate(205.312 75.187)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M10.85,7.963C11.309,3.313,9.9.057,6.548,0,4.64-.032,2.9,1.515,1.635,4.495-.794,10.21-.7,19.566,3.149,20.167c4.2.653,7.1-6.1,7.7-12.2M9.1,9.8c-.86,4.895-3.643,9.68-6.06,9.176C.983,18.549.611,12.232,1.783,7.854,3.014,3.249,4.935.67,7.1,1.162c2.2.5,2.825,3.933,2,8.639",
    transform: "translate(201.91 69.761)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M0,6.988C5.066,5.63,14.824,1.565,22.108.527a39.051,39.051,0,0,1,15.853.581c3.475.965,6.728,2.543,8.445,5.015,2.2,3.164-1.865,7.361-6.135,5.823-1.783-.641-2.216-3.128.113-4.778a.691.691,0,0,1,.832.12c.119.165.039.4-.168.573-1.784,1.51-1.175,3.276.637,3.341,2.219.08,4.881-1.823,3.658-4.385-.769-1.611-3.925-3.333-7.837-4.43a34.274,34.274,0,0,0-14.952-.6C13.912,3.459,6.714,6.748.008,8.173Z",
    transform: "translate(211.876 72.578)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M9.262,32.919c-4.75.967-5.645-.6-6.223-5.194-.5-3.957-.387-7.664-1.418-14.9C.838,7.347-1.806,1.486,2.016.575A30.76,30.76,0,0,1,8.695.031c1.94-.027,3.37-.237,4.6.96,1.375,1.342,1.154,4.978,1.9,7.583.759,5.583,1.016,10.076,1.476,12.1C18.306,27.889,17.9,31.651,13.984,32.1q-2.378.346-4.722.822",
    transform: "translate(458.483 380.912)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M8,1.346A1.054,1.054,0,0,1,8.845.034a1.368,1.368,0,0,1,1.507.7C11.4,2.844,12.187,11.3,1.749,11.419A1.609,1.609,0,0,1,.024,10.275,1.073,1.073,0,0,1,1.187,8.99C9.285,9.275,8.749,3.3,8,1.346",
    transform: "translate(352.376 392.67)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M4.914,0a.241.241,0,0,1,.08.008c.27.068.357.472.242.809A3.463,3.463,0,0,1,4.42,2,5.886,5.886,0,0,1,1.45,3.8a1.252,1.252,0,0,1-1.283-.24.487.487,0,0,1-.145-.481.76.76,0,0,1,.635-.4A5.052,5.052,0,0,0,3.911.909C4.072.717,4.13.6,4.225.476c.046-.06.114-.144.114-.144A.809.809,0,0,1,4.9,0Z",
    transform: "translate(197.968 97.645)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M4.158,1.218c.085-.228.26-.3.4-.256a.313.313,0,0,1,.179.412,6.189,6.189,0,0,1-2.081,3.2,1.431,1.431,0,0,1-1.99-.117C-.151,3.392-.161,1.906.338.2A.292.292,0,0,1,.707.016a.29.29,0,0,1,.16.357c-.318,1.406-.511,2.9.215,3.653a.9.9,0,0,0,1.086.068,5.789,5.789,0,0,0,1.99-2.876",
    transform: "translate(204.026 81.709)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M211,10.972c.86,2.261,1.375,4.206-.164,6.326-2.5,3.443-7.1,3.769-13.656,5.722-10.471,3.119-20.411,6.247-30.206,10.222-19.6,7.954-39.042,17.627-63.985,25.686C86.972,64.1,67.872,73.066,46.775,81.051,36.752,84.845,26.269,88.28,15.711,91.945c-2.022.7-5.219,2.541-7.885,1.821-1.029-.278-1.878-1.6-2.66-2.706-.9-1.271-2-2.806-3.143-4.434-2.509-3.582-3.437-9.007,1.716-11.31,10.349-4.648,19.128-8.354,31.324-13.186,6.121-2.426,25.482-7.191,43.64-15.1,22.133-9.639,34.621-15.216,48.8-20.46,18.926-7,33.492-9.942,55.477-19.235,1.959-.827,4.02-2.067,5.881-3.035,4.308-2.241,8.091-4.165,10.944-4.3,4.03-.184,8.054,2.711,11.193,10.964",
    transform: "translate(219.977 262.685)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M65.584.733C61.29,34.721,57.465,67.579,48.618,111.018l-39.963-1.7C4.273,70.03,1.742,34.268,0,0Z",
    transform: "translate(48.994 29.225)",
    fill: "#ea3a4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M20.85,0c.036,2.027.308,4.073.377,6.024.28,7.894-.265,15.9-.044,23.742.012.388.024.781.032,1.169q-5.5-.276-11-.669-1.58-.114-3.16-.236l-.28-.02C4.518,29.858,2.263,29.7,0,29.586c.056.833.108,1.674.164,2.511,6.008.22,11.976.641,17.979.861q1.568.061,3.136.109c.525,18.788.817,37.836,1.229,56.76.136,6.612-.016,13.317.06,19.9l1.694.072c-.028-8.383.156-16.405.064-25.068q-.09-8.8-.156-17.591l-.008-.833c-.088-9.268-.208-18.563-.469-27.888-.048-1.77-.108-3.528-.164-5.29,12.052.316,24.115.216,36.2-.148.073-.545.144-1.089.217-1.63q-18.215.534-36.487-.308c-.088-2.964-.156-5.936-.136-8.963.032-5.387.18-10.754-.064-16.137-.092-1.983-.424-3.953-.549-5.923Z",
    transform: "translate(50.707 29.478)",
    fill: "#306e57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M29.8,30.375c-2.68,3.613-10.778,8.942-14.6,11.677a1.381,1.381,0,0,1-1.69.1.908.908,0,0,1,.224-1.442A139.226,139.226,0,0,0,28.4,30.041C18.442,23.2,11.52,17.483,6.122,11.653,2.409,7.64-.783,1.7.17.411c1.013-1.37,5.643.8,10.834,4.8C17.578,10.278,26.027,16.97,30.485,27.69c9.249-8.046,17.286-17.07,21.271-17.65,1.954-.284,1.878,1.233.913,2.94C47.694,21.771,37.141,27.9,31.246,29.931A136.236,136.236,0,0,1,44.37,43.582c.833,1.177-.465,2.2-1.265,1.274C37.968,38.977,33.648,34.13,29.8,30.375m-.067-2.033C24.588,15.156,5.57,1.191,1.043.868c2.755,9.7,17.788,19.757,27.775,28.248Zm2.074.129c8.687-3.42,16.9-10.385,20.318-16.818C48.48,12.9,41.326,21.07,31.8,28.471",
    transform: "translate(42.709 0)",
    fill: "#2a8b5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M2.444,7.84a1.186,1.186,0,0,1-1,1.2,1.494,1.494,0,0,1-1.426-1.4A6.808,6.808,0,0,1,4.294.676a9,9,0,0,1,8.183.732c1.1.625,1.273,1.336,1.065,1.857-.268.66-1.245.924-2.3.5-2.311-.934-4.181-1.179-5.607-.7C3.938,3.622,2.508,5.086,2.444,7.84",
    transform: "translate(122.818 225.071)",
    fill: "#345f5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M159.57,0C137.1,9.952,109.758,20.4,81.86,25.893,55.2,31.143,28.048,31.7,3.905,30.23L0,52.311c65.027,6.9,135.291,5.591,169.715-22.493Z",
    transform: "translate(97.611 103.389)",
    fill: "#c93f4f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M37.286,11.982C31.724,7.9,17.857-1.848,16.2.307c-.949,1.242,4.518,6.288,7.238,9.236C15.567,8.93.231,8.774,0,12.9c-.252,4.474,16.934,7.894,35.8,6.828Z",
    transform: "translate(59.179 129.455)",
    fill: "#153939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M8.145.043C5.157-.3,3.855,1.417,3.3,5.1c-.389,3.609-.785,7.221-1.286,10.966-.421,3.14-.261,5.756-1.542,9.765-.933,2.908-.729,4.742,2.915,5.451,2.872.561,3.577.721,8.231,1.377,3.148.445,4.35-1.129,4.562-4.145.352-4.882.377-7.277,1.142-10.83,1.077-5.018.821-7.566,1.453-11.206.625-3.62-.84-5.988-3.949-5.9A37.841,37.841,0,0,1,8.145.043",
    transform: "translate(90.299 128.125)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M15.529,0A18.265,18.265,0,0,0,2.4,5.707C.247,8.006-.929,11.486.912,14.8A10.293,10.293,0,0,0,7.341,19.8c4.948,1.207,10.129-1.049,13.494-4.133a14.016,14.016,0,0,0,3.111-3.708s.437-.619.72-1.131A7,7,0,0,0,22.3,1.863,11.971,11.971,0,0,0,15.529,0",
    transform: "translate(304.192 53.374)",
    fill: "#e2e7e7",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantaWithGift);
export default __webpack_public_path__ + "static/media/santaWithGift.4406b63299db4ea1895280695878eab1.svg";
export { ForwardRef as ReactComponent };